import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactInfo from './components/ContactInfo';
import ContactForm from './components/ContactForm';
import MapSection from './components/MapSection';
import FAQSection from './components/FAQSection';
import { useSEO } from '../../hooks/useSEO';
import { SchemaMarkup } from '../../components/SEOHead';

const contactSchema = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  name: 'Contacto Anthony Sánchez Couture',
  description: 'Contacta con nuestro atelier de alta costura en Barcelona. Reserva cita, consulta precios o visítanos en Rambla de Catalunya, 85.',
  url: 'https://anthonysanchezc.com/contacto',
  mainEntity: {
    '@type': 'LocalBusiness',
    name: 'Anthony Sánchez Couture',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Rambla de Catalunya, 85, Principal - 2',
      addressLocality: 'Barcelona',
      addressRegion: 'Cataluña',
      postalCode: '08008',
      addressCountry: 'ES',
    },
    telephone: '+34 625 46 34 20',
    email: 'anthosanchez3108@gmail.com',
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '10:00',
        closes: '19:00',
      },
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Saturday'],
        opens: '10:00',
        closes: '14:00',
      },
    ],
  },
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Inicio',
      item: 'https://anthonysanchezc.com',
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Contacto',
      item: 'https://anthonysanchezc.com/contacto',
    },
  ],
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '¿Cómo reservo una cita para alta costura?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Puedes reservar una cita privada a través del formulario en la página de Alta Costura o contactándonos directamente por teléfono o email. Las consultas son martes a sábado en horario de mañana, siempre con cita previa.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Cuánto tiempo tarda un arreglo?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Los ajustes simples suelen estar listos en 3-5 días. Reparaciones más complejas pueden requerir hasta una semana. Si tienes urgencia, consúltanos.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Hacéis envíos de la tienda online?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Actualmente las piezas de alta costura requieren consulta previa y citas de prueba. Para la cápsula prêt-à-porter, contacta con nosotros y gestionaremos el envío personalizado con seguro incluido.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Cuál es el precio de un vestido de alta costura?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Cada pieza es única y se presupuesta individualmente. Nuestros vestidos de gala parten desde 4.800€ y los de novia desde 7.200€. Durante la consulta inicial te presentamos un presupuesto detallado sin compromiso.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Trabajáis con clientes internacionales?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Sí. Ofrecemos consultas online iniciales y coordinamos sesiones de prueba durante visitas a Barcelona. También podemos gestionar envíos a cualquier país.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Ofrecéis servicio de asesoría de imagen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Sí. Durante la consulta de alta costura, la asesoría de imagen está incluida en el proceso. También ofrecemos sesiones de asesoría independientes para revisión de armario y compras personalizadas.',
      },
    },
  ],
};

export default function Contacto() {
  useSEO({
    title: 'Contacto | Alta Costura Barcelona | Reserva Cita | Anthony Sánchez Couture',
    description: 'Contacta con nuestro atelier de alta costura en Barcelona. Rambla de Catalunya 85, Eixample. Reserva cita privada, consulta precios o solicita arreglos.',
    keywords: 'contacto alta costura Barcelona, reserva cita, atelier Barcelona, vestidos gala consulta, arreglos ropa contacto, Eixample',
    canonical: '/contacto',
    ogTitle: 'Contacto — Reserva Cita en nuestro Atelier Barcelona',
    ogDescription: 'Atelier de alta costura en Rambla de Catalunya 85, Barcelona. Reserva cita, consulta precios o solicita arreglos.',
    ogType: 'website',
  });

  return (
    <div className="min-h-screen bg-white">
      <SchemaMarkup schema={contactSchema} />
      <SchemaMarkup schema={breadcrumbSchema} />
      <SchemaMarkup schema={faqSchema} />
      <Navbar />
      <main>
        <ContactHero />
        <ContactInfo />
        <ContactForm />
        <MapSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}